import { FC, useContext, useEffect, useMemo, useState } from 'react';
import { IEventMetadata, IFormFieldMetadata, IFormMetadata, IFormSectionMetadata, IFormVersionMetadata, ISourceData, ISourceDataConfiguration, ISourceDataConfigurationEvent, ISourceDataConfigurationForm, ISourceDataConfigurationFormSection, ISourceDataConfigurationFormVersion, ISourceDataEvent, ISourceDataField, ISourceDataForm, ITrialFormMetadata } from '@/api/dtos';
import { BasicAlert, Checkbox, CollapsiblePanel, ICollapsiblePanelComponentProps, InputOnlyField, Markdown, Select } from '@ngt/forms';
import { alpha, Box, Button, Chip, Divider, styled, Tooltip, Typography, lighten, darken, TextField, MenuItem, Paper } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faCodeBranch, faCommentAlt, faFlag, faMessageLines, faRepeat, faSquareList } from '@fortawesome/pro-duotone-svg-icons';
import { faExclamationTriangle, faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { ISourceDataFormFieldComponentProps } from '@/utilities/forms/SourceDataFormProcessor';
import SourceDataFormField from '../common/SourceDataFormField';

const Title = styled(Typography)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing(2)
}));

const IconContainer = styled(Box)(({ theme }) => ({
    marginRight: theme.spacing(2)
}));

const RepeatChip = styled(Chip)(({ auto, theme }: any) => ({
    marginLeft: auto ? 'auto' : theme.spacing(1)
}));

const Content = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2, 2, 2, 2),
    display: 'flex',
    alignItems: 'flex-start'
}));

const Field = styled(Box)(({ theme }) => ({
    minWidth: 200,
    minHeight: 40,
    marginLeft: 'auto',
    border: theme.palette.mode === 'dark' ? 
        `solid 1px ${alpha(theme.palette.common.white, 0.12)}` :
        `solid 1px ${alpha(theme.palette.common.black, 0.12)}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1, 1, 1, 1),
    background: theme.palette.mode === 'dark' ? 
        lighten(theme.palette.common.black, 0.15) :
        darken(theme.palette.common.white, 0.01)
}));

const FieldLabel = styled(Box)(({ theme }) => ({
    minWidth: 200,
    minHeight: 40,
    padding: theme.spacing(1, 1, 1, 1)
}));

const Reviewed = styled(Box)(({ theme }) => ({
    marginLeft: theme.spacing(2),
    minWidth: 120
}));

const ReviewedCheckbox = styled(Box)(({ theme }) => ({
    '& > div > div > label': {
        marginRight: 0
    }
}));

const Format = styled('pre')(({ theme }) => ({
    ...theme.typography.body1,
    margin: 0,
    whiteSpace: 'pre-wrap'
}));

const ActionButton = styled(Button)(({ theme }) => ({
    minWidth: '40 !important',
    height: 40,
    width: 40,
    padding: 0,
    marginLeft: theme.spacing(2)
}));

const ActionChip = styled(Chip)(({ theme }) => ({
    position: 'absolute',
    top: -2,
    right: -2,
    transform: 'scale(0.5)',
    background: theme.palette.mode === 'dark' ? 
        lighten(theme.palette.common.black, 0.15) :
        darken(theme.palette.common.white, 0.01)
}));

const Wrapper = styled(Paper)(({ section, theme }: any) => ({
    background: section === '1' ? 
        theme.palette.mode === 'dark' ? 
            lighten(theme.palette.common.black, 0.18) :
            darken(theme.palette.common.white, 0.03) :
            undefined
}));


const SourceDataFormFieldTitled: FC<ISourceDataFormFieldComponentProps> = (props) => {
    return (
        <Wrapper 
            // @ts-ignore
            section={!props.formSectionMetadata ? undefined : '1'}
            square
        >
            <SourceDataFormField {...props} />
            <Divider />
        </Wrapper>
    );
}

export default SourceDataFormFieldTitled;